import de from 'date-fns/locale/de'
import distanceInWordsFns from 'date-fns/distance_in_words'
import en from 'date-fns/locale/en'
import i18n from 'src/i18n/i18n'
import parseDate from 'date-fns/parse'
import { date as quasarDate } from 'quasar'

const dayDifference = {
  '-1': i18n.t('yesterday'),
  0: i18n.t('today'),
  1: i18n.t('tomorrow')
}

function handleTimezoneOffset (date) {
  const timezoneDifference = (new Date()).getTimezoneOffset()

  if (timezoneDifference < 0) {
    return quasarDate.subtractFromDate(date, { minutes: timezoneDifference })
  }

  return quasarDate.addToDate(date, { minutes: timezoneDifference })
}

function parseDateTime (date) {
  const parsedDate = parseDate(date)

  return handleTimezoneOffset(parsedDate)
}

function distanceInWords (date, addSuffix = true) {
  return distanceInWordsFns(Date.now(), date instanceof Date ? date : parseDateTime(date), {
    locale: i18n.locale === 'de' ? de : en,
    addSuffix: addSuffix
  })
}

function distanceInWordsOrFormat (date, maxDiff, format) {
  date = date instanceof Date ? date : parseDate(date)

  const diff = quasarDate.getDateDiff(date, Date.now(), 'days')

  if (Math.abs(diff) > maxDiff) {
    return quasarDate.formatDate(date, format)
  }

  if (dayDifference[diff]) {
    return dayDifference[diff]
  }

  return distanceInWords(date)
}

function currentUtcDateTime () {
  const now = new Date()

  return new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds())
}

function convertToUTC (date) {
  const timezoneDifference = (new Date()).getTimezoneOffset()

  if (timezoneDifference < 0) {
    return quasarDate.addToDate(date, { minutes: timezoneDifference })
  }

  return quasarDate.subtractFromDate(date, { minutes: timezoneDifference })
}

export { parseDateTime, distanceInWords, distanceInWordsOrFormat, currentUtcDateTime, convertToUTC }
